export const upperCase = (value: string) => {
    return ("" + value).toUpperCase();
  }